const setSitesToErrorMessageModalCloneCheck = {
  errSite: 'have a checklist.'
};

export default setSitesToErrorMessageModalCloneCheck;
